<template>
    <div id="app">
        <main-header nowtab="creator"></main-header>
        <main class="adjuster">
            <div v-if="!isAuthor">
                <br/>
                <div class="render-text" v-if="!hasLogin">
                    <blockquote>
                        请<a href="/user/login.html?from">登录</a>以进入创作者界面
                    </blockquote>
                </div>
                <div class="render-text">
                    <blockquote>
                        您当前不是创作者，若需要发塔<br/>
                        请加入群 <b>HTML5发塔群(876332519)</b> 申请成为创作者
                    </blockquote>
                </div>
                <br/>
                <div class="render-text" v-html="parse(introText)"></div>
            </div>
            <div v-else>
                <a-result v-if="!hasTower"
                    title="您还没有发布过塔"
                >
                    <template slot="extra">
                        发塔流程：<br/>
                        1. 点击上传塔, 将塔传到服务器上<br/>
                        2. 点击上架按钮, 将塔公开
                    </template>
                </a-result>
                <div class="tower-list">
                    <a-list item-layout="vertical" :data-source="list"
                        class="list-container" :loading="loading"
                        :split="false" size="large"
                        :locale="{ emptyText: '还没有上传过塔' }"
                    >
                        <!-- <a-list-item slot="header" class="upload-tower-button"
                            @click="openUploadDialog"
                        >
                            <a-icon type="plus"/>上传塔
                        </a-list-item> -->
                        <a-list-item slot="renderItem" slot-scope="item" class="tower-item">
                            <a class="tower-info" :href="`/tower/backstage/?name=${ item.name }`" target="_blank">
                                <div>
                                    <span class="tower-info-title">{{ item.title }}</span>
                                    <span class="tower-info-name">[{{ item.name }}]</span>
                                </div>
                            </a>
                            <div class="tower-label" :style="{ backgroundColor: TOWER_STATUS[item.status].color }">
                                <span>{{ TOWER_STATUS[item.status].label }}</span>
                            </div>
                        </a-list-item>
                    </a-list>
                </div>
                <a-modal
                    title="上传塔" class="upload-dialog"
                    :visible="uploadVisible" width="85%"
                    :confirm-loading="uploading"
                    @ok="upload"
                    @cancel="() => uploadVisible = false"
                >
                    <a-form-model ref="uploadForm" class="upload-form"
                        :model="uploadForm" :rules="uploadRules"
                    >
                        <a-form-model-item prop="file"
                            :labelCol="{ span: 3 }" :wrapperCol="{ span: 18, offset: 3 }"
                        >
                            <a-upload
                                name="file" accept=".zip"
                                :multiple="false" :before-upload="() => false"
                                @change="handleFileChange" :fileList="fileList"
                            >
                                <a-button><a-icon type="upload" />塔的文件(只支持.zip格式)</a-button>
                            </a-upload>
                        </a-form-model-item>
                        <a-form-model-item prop="title" label="标题">
                            <a-input v-model="uploadForm.title"></a-input>
                        </a-form-model-item>
                        <a-form-model-item prop="name" label="塔ID">
                            <a-input v-model="uploadForm.name"></a-input>
                        </a-form-model-item>
                        <a-form-model-item v-if="uploading" :wrapperCol="{ span: 18, offset: 3 }">
                            <a-progress :percent="uploadprogress" :format="uploadingFormat" status="active" />
                        </a-form-model-item>
                    </a-form-model>
                </a-modal>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader'
import Footer from '@/components/Footer'
import { createFormData, getSSRdata } from '../../utils/utils'
import { mapState } from 'vuex'
import axios from 'axios'

const TOWER_STATUS = {
    'private': { label: '测试', color: '#BBBBBB' },
    'public':  { label: '公开', color: '#81C784' },
}

export default {
    data() {
        return {
            isAuthor: false,
            introText: "",
            list: [],
            loading: false,
            TOWER_STATUS,
            // 上传
            uploadVisible: false,
            uploadprogress: 0,
            uploading: false,
            fileList: [],
            uploadForm: {
                file: false,
                title: "",
                name: "",
            },
            uploadRules: {
                file: [
                    { validator: (rule, value, res) => {
                        if (value) {
                            res();
                        } else {
                            res(new Error("必须提供塔的压缩包"));
                        }
                    }, trigger: 'blur' }
                ],
                title: [
                    { required: true, trigger: 'blur' }
                ],
                name: [
                    { required: true, trigger: 'blur' },
                    { validator: (rule, value, res) => {
                        if (!/^[a-zA-Z0-9_]+$/.test(value)) {
                            res(new Error("塔ID只能由大小写字母和数字组成"));
                        } else {
                            axios.post("/backend/towers/checkName.php", createFormData({
                                name: value
                            })).then(({ data }) => {
                                if (data.code == 0) { 
                                    res();
                                } else {
                                    res(new Error(`塔ID[${ value }]已经被占用`));
                                }
                            })
                        }
                    }, trigger: 'blur' },
                ],
            },
            uploadingFormat(percent) {
                if (percent == 100) return "正在构建";
                else return percent + '%';
            },
        }
    },
    computed: {
        ...mapState({ hasLogin: 'hasLogin' }),
        hasTower() {
            return !this.list.every((e) => e.status != 'public');
        }
    },
    async created() {
        const data = getSSRdata("creator");
        if (data.code == 0) { // 创作者
            this.isAuthor = true;
            await this.loadTowerList();
        } else { // 一般通过
            this.isAuthor = false;
            this.introText = data.text;
        }
    },
    methods: {
        /**
         * @param {string}raw
         */
        parse(raw, space = true) {
            if (!space)
                raw = raw.replace(/ /, "&nbsp;");
            return raw
                .replace(/\n<br>/g, "<br>")
                .replace(/[\n\r]/g, "<br>");
        },
        async loadTowerList() {
            this.loading = true;
            try {
                const { data } = await axios.get("/backend/creator/towerList.php");
                this.list = data.list;
            } catch (e) {
                this.$message.error(`拉取列表失败: ${ e }`);
            } finally {
                this.loading = false;
            }
        },
        openUploadDialog() {
            this.uploadVisible = true;
        },
        handleFileChange(info) {
            switch(info.file.status) {
                case "remove":
                    this.uploadForm.file = false;
                    break;
                default: 
                    this.uploadForm.file = true;
            }
            this.fileList = info.fileList;
        },
        upload() {
            this.$refs.uploadForm.validate(async (valid) => {
                if (valid) {
                    this.uploadForm.file = this.fileList[0].originFileObj;
                    this.uploadprogress = 0;
                    this.uploading = true;
                    try {
                        const { data } = await axios.post("/backend/creator/upload.php",
                            createFormData(this.uploadForm), {
                            onUploadProgress: (e) => {
                                this.uploadprogress = (e.loaded / e.total * 100 | 0);
                            }
                        });
                        this.fileList = [];
                        if (data.code == 0) {
                            this.$message.success("上传成功");
                            this.$refs.uploadForm.resetFields();
                        } else {
                            this.$error({
                                title: '上传失败',
                                width: '85%',
                                content: h => (<pre class="message">{ data.message }</pre>),
                            });
                        }
                    } catch (e) {
                        this.$message.error(`上传成功: ${ e }`);
                    } finally {
                        this.uploading = false;
                    }
                }
            });
        }
    },
    components: {
        MainHeader, Footer,
    }
}
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
    }
}
.list-container {
    font-size: 18px;
    .ant-list-item {
        background: #f1f1f1;
    }
}
.tower-list {
    margin: 0 20px;
    .tower-item {
        display: flex;
        padding: 0px;
        margin-bottom: 12px;
        height: 58.6px;
        .tower-info {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-grow: 1;
            color: inherit;
            &-title {
                margin-right: 10px;
            }
            &-name {
                font-size: 16px;
                color: rgba(0,0,0,0.35);
            }
        }
        .tower-label {
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.upload-tower-button {
    cursor: pointer;
}
.upload-form {
    max-width: 600px;
}
</style>

<style lang="less">
.upload-dialog .ant-modal {
    max-width: 800px;
}
.render-text {
    font-size: 16px;
    text-align: left;
    color: #444444;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
    overflow-wrap: anywhere;
}
</style>
